import { mutations } from './mutations';
import { getters } from './getters';
import { actions } from './actions';
import { StaffState } from './state';

const defaultState: StaffState = {
  staffDashboardStatistics: {
    completed_tasks: {
      available: false,
      value: 0,
    },
    time_spent: {
      available: false,
      value: 0,
    },
    donations_sum: {
      available: false,
      value: 0,
    },
    new_subscriptions: {
      available: false,
      value: 0,
    },
    new_registrations: {
      available: false,
      value: 0,
    },
    tasks_of_new_registrations: {
      available: false,
      value: 0,
    },
    available_periods: [],
    current_period: 'today',
  },
  staffDashboardStatisticsByCountries: [],
  staffDashboardStatisticsByStaff: [],
  usersImportsList: [],
};

export const staffModule = {
  state: defaultState,
  mutations,
  actions,
  getters,
};
